<template>
  <div class="ConfigurableText" v-html="text"> </div>
</template>
<script>
import api from '@/api/basic'
import marked from 'marked'

export default {
  name: 'AgebotOverview',
  props: ['id'],
  async mounted () {
    let result = await api.config(this.id)
    if ((result) && (result.length > 0)) {
      this.text = marked(result[0].value)
    }
  },
  data () {
    return {
      text: ''
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/partials/ConfigurableText.vue